import { createFileRoute } from '@tanstack/react-router';

import { EarlyAccessPage } from '../components/marketing/EarlyAccessPage';

/** /earlyaccessartist — the early-access page with the artist toggle preset. */
export const Route = createFileRoute('/earlyaccessartist')({
  component: () => <EarlyAccessPage initialLeadType="artist" />,
});
